import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Opens the shared signup / turn-off modals from any program widget and
// closes them after a successful turbo-stream subscribe or unsubscribe.
export default class extends Controller {
  static targets = [
    "signupModal",
    "turnOffModal",
    "signupProgramType",
    "signupCategory",
    "signupNoun",
    "signupIcon",
    "turnOffCategory",
    "turnOffNoun",
    "turnOffIcon",
    "turnOffForm",
    "nameField",
    "emailField"
  ]

  static values = {
    name: String,
    email: String,
    destroyUrlTemplate: String
  }

  connect() {
    this.signupBootstrapModal = Modal.getOrCreateInstance(this.signupModalTarget)
    this.turnOffBootstrapModal = Modal.getOrCreateInstance(this.turnOffModalTarget)
  }

  disconnect() {
    this.signupBootstrapModal?.dispose()
    this.turnOffBootstrapModal?.dispose()
  }

  openSignup(event) {
    event.preventDefault()
    this.#applyCategory(event.currentTarget.dataset, {
      category: this.signupCategoryTarget,
      noun: this.signupNounTarget,
      icon: this.signupIconTarget
    })
    this.signupProgramTypeTarget.value = event.currentTarget.dataset.programType
    this.nameFieldTarget.value = this.nameValue
    this.emailFieldTarget.value = this.emailValue
    this.#clearSignupErrors()
    this.signupModalTarget.addEventListener(
      "shown.bs.modal",
      () => this.nameFieldTarget.focus(),
      { once: true }
    )
    this.signupBootstrapModal.show()
  }

  openTurnOff(event) {
    event.preventDefault()
    this.#applyCategory(event.currentTarget.dataset, {
      category: this.turnOffCategoryTarget,
      noun: this.turnOffNounTarget,
      icon: this.turnOffIconTarget
    })
    this.turnOffFormTarget.action = this.destroyUrlTemplateValue.replace(
      "PLACEHOLDER",
      encodeURIComponent(event.currentTarget.dataset.programType)
    )
    this.turnOffBootstrapModal.show()
  }

  closeSignup(event) {
    event?.preventDefault()
    this.signupBootstrapModal.hide()
  }

  closeTurnOff(event) {
    event?.preventDefault()
    this.turnOffBootstrapModal.hide()
  }

  onSubmitEnd(event) {
    if (!event.detail.success) return

    this.signupBootstrapModal.hide()
    this.turnOffBootstrapModal.hide()
  }

  #applyCategory(dataset, targets) {
    targets.category.textContent = dataset.categoryLabel
    targets.noun.textContent = dataset.alertNoun
    targets.icon.className = `ph ${dataset.icon}`
  }

  #clearSignupErrors() {
    const errors = this.signupModalTarget.querySelector("#program-alert-signup-errors")
    if (errors) errors.innerHTML = ""
  }
}
